import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SettingsTopSection from "../../ui/settings_top_section";
import PersonalTab from "../setting_tabs/PersonalTab";
import IntegrationTab from "../setting_tabs/IntegrationTab";
import BillingTab from "../setting_tabs/BillingTab";
import { DEFAULT_FONT_FAMILY } from "../../../config/fontConfig";

const SettingsPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determine initial tab from URL
  const getInitialTab = () => {
    const path = location.pathname;
    if (path.includes('/settings/integration')) return 'Integration';
    if (path.includes('/settings/billing')) return 'Billing';
    return 'Details';
  };

  const [selectedTab, setSelectedTab] = useState(getInitialTab());

  const tabs = [
    "Details",
    "Integration",
    "Billing",
  ];

  // Update URL when tab changes
  const handleTabChange = (tab: string) => {
    setSelectedTab(tab);
    
    // Update URL based on selected tab
    switch(tab) {
      case 'Details':
        navigate('/dashboard/settings', { replace: true });
        break;
      case 'Integration':
        navigate('/dashboard/settings/integration', { replace: true });
        break;
      case 'Billing':
        navigate('/dashboard/settings/billing', { replace: true });
        break;
    }
  };

  // Sync tab with URL changes (browser back/forward)
  useEffect(() => {
    setSelectedTab(getInitialTab());
  }, [location.pathname]);

  return (
    <div className="h-screen px-6 py-4 flex flex-col">
      {/* top header */}
      <SettingsTopSection />

      {/* tab bar */}
      <div className="flex flex-row items-center mt-10 border-b border-[#DEDEDE]">
        {tabs.map((tab) => (
          <div key={tab} className="ml-8 first:ml-0 text-center">
            <button
              onClick={() => handleTabChange(tab)}
              className={`${
                selectedTab === tab ? "text-[#050505]" : "text-[#6C707F]"
              } font-medium text-base 3xl:text-[16px] 4xl:text-[18px]`} style={{ fontFamily: DEFAULT_FONT_FAMILY }}
            >
              {tab}
            </button>

            <div
              className={`h-[1px] ${
                selectedTab === tab ? "bg-[#050505]" : "bg-transparent"
              } mt-1 mx-auto`}
            ></div>
          </div>
        ))}
      </div>

      {/* Tab content */}
      <div className="mt-6 flex-1 min-h-0 pb-4 overflow-y-auto custom-scrollbar-overlay">
        {selectedTab === "Details" && <PersonalTab />}
        {selectedTab === "Integration" && <IntegrationTab />}
        {selectedTab === "Billing" && <BillingTab />}
      </div>
    </div>
  );
};

export default SettingsPage;